import store from '@/store'
import Vue from "vue";
import { baseUrlt, downUrl, xxH5Url } from "../../api";

export default {
  methods: {
    deleteNullPrototype(params) {
      if (!(typeof params == 'object')) {
        return
      }

      var obj = Object.assign({}, params)

      for (var key in obj) {
        if (obj.hasOwnProperty(key) && (obj[key] === null || obj[key] === undefined || obj[key] === '')) {
          delete obj[key];
        }
      }
      return obj
    },
    setPrototypeNull(obj) {
      for (var i in obj) {
        obj[i] = ''
      }
    },
    delProp(obj, props) {
      var obj = Object.assign({}, obj)
      props.forEach(prop => {
        Object.keys(obj).forEach(key => {
          if (prop === key) {
            delete obj[key]
          }
        })
      })
      return obj
    },
    getLabelName(arr, k1, k2, id) {
      let label = ''
      arr.map(item => {
        if (item[k1] == id) {
          label = item[k2]
        }
      })
      return label
    },
    getLabelNameNew({ arr = [], idKey = 'id', valKeys = [], id = '' } = {}) {
      let labelObj = {}
      arr.map(item => {
        if (item[idKey] == id) {
          if (valKeys.length) {
            valKeys.map(k => {
              labelObj[k] = item[k]
            })
          }else{
            labelObj = item
          }
        }
      })
      return labelObj
    },
    getDateStr(timestamp, mark = '/') {
      var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000

      let Y = date.getFullYear() + mark;

      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + mark;

      let D = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();


      return Y + M + D;
    },
    getFileName(url) {
      return url.split('/')[url.split('/').length - 1]
    },
    goHomee(system) {
      if (system == 'android') {
        client.goBack();
      } else if (system == 'ios') {
        // goHome();
        window.webkit.messageHandlers.goHome.postMessage(['返回首页goHome'])
      } else if (system == 'h5') {
        // goHome();
        location.href = `${xxH5Url}#/testTansform?token=${localStorage.getItem('token')}`
      } else {
        history.back()
      }
    },
    organArr: [],
    getOrgBylevel(organs, level) {
      if (organs && organs.length) {
        organs.map((item) => {
          if (item.level == level) {
            this.organArr.push({
              id: item.id,
              name: item.name,
              label: item.structure_names,
            });
          }
          if (item.sub && item.sub.length) {
            this.getOrgBylevel(item.sub, level)
          }
        });
      }
    },
    getTimeStr(timestamp, mark = '/') {
      var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000

      let Y = date.getFullYear() + mark;

      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + mark;

      let D = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

      let h = (date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()) + ':';

      let m = (date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()) + ':';

      let s = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();

      // return Y + M + D;
      return Y + M + D + ' ' + h + m + s;
    },
    getDateDistance(time) {
      var str = ''
      if (time) {
        var curTimestamp = parseInt(new Date().getTime() / 1000); //当前时间戳
        var second = curTimestamp - parseInt(new Date(time).getTime() / 1000); // 参数时间戳与当前时间戳相差秒数
        var date = new Date(time)
        var Y = date.getFullYear()
        if (second < 60) {
          str = '刚刚~'
        } else if (second > 60 && second < 3600) {
          str = parseInt(second / 60) + '分钟前~'
        } else if (second >= 3600 && second < 86400) {
          str = parseInt(second / 3600) + '小时前~'
        } else if (Y == new Date().getFullYear() && date.getMonth() == new Date().getMonth()) {
          str = parseInt(second / 86400) + '天前~'
        } else if (Y == new Date().getFullYear() && date.getMonth() < new Date().getMonth()) {
          str = parseInt(new Date().getMonth() - date.getMonth()) + '月前~'
        } else if (Y < new Date().getFullYear()) {
          str = '超过一年'
        }

      }
      return str
    },
    checkPrmissions(page, key) {
      let flag = true;
      const userInfo = store.state.userInfo
      switch (page) {
        case "sxrz":
          if (userInfo.usertype == 1 && key == "addEditDel") flag = false
          break;
        case "courseProjectsMangeTeacher":
          if (userInfo.usertype == 4 && key == "addEditDel") flag = false
          break;
        case "questionManage":
          if (userInfo.schoolid == 1 && key == "aibtn") flag = false
          break;
        case "learnSafeCourse":
          if (userInfo.schoolid == 1 && key == "aitest") flag = false
          break;
      }
      return flag
    },
    easyArrToObj(arr, value = "value", label = "label") {
      return arr.reduce((obj, item) => {
        obj[item[value]] = item[label]
        return obj
      }, {})
    },
    // 下载一个文件地址:先 fetch 成 blob 再触发浏览器下载
    async downloadFromUrl(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Network response was not ok');
        const blob = await response.blob();
        this.downloadBlob(blob, this.getFileName(url));
      } catch (error) {
        console.error('Download failed:', error);
      }
    },
    // 触发浏览器下载 blob
    downloadBlob(blob, filename) {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url); // 释放内存
    },
    // 调用后端接口并把返回的"文件流"直接下载下来(带 token,适用于返回 PDF/Excel 的接口)
    async downloadApiFile(url, filename, method = 'post', data = null) {
      const loading = Vue.prototype.$loading({
        lock: true,
        background: 'rgba(255, 255, 255, 0.5)',
      });
      try {
        const options = {
          method: method.toUpperCase(),
          headers: {
            token: store.state.userInfo ? store.state.userInfo.userToken : '',
          },
        };
        // 有参数时按表单提交(与 axios 封装的默认格式保持一致)
        if (data && options.method !== 'GET') {
          options.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
          options.body = new URLSearchParams(data).toString();
        }
        const response = await fetch(baseUrlt + url, options);
        if (!response.ok) throw new Error('HTTP ' + response.status);
        const blob = await response.blob();
        this.downloadBlob(blob, filename || 'download');
      } catch (error) {
        console.error('Download failed:', error);
        Vue.prototype.$message.error('下载失败');
      } finally {
        loading.close();
      }
    },
    async downloadData(oriurl, method = 'get', params = null) {
      const url = downUrl + oriurl;
      const loading = Vue.prototype.$loading({
        lock: true,
        background: 'rgba(255, 255, 255, 0.5)',
        // target: document.querySelector(".loading-area") //设置加载动画区域
      });
      // 构建请求配置
      const config = {
        method: method.toUpperCase(),
        headers: {
          'Content-Type': 'application/json',
        }
      };

      // 添加 token 到请求头
      config.headers['token'] = store.state.userInfo ? store.state.userInfo.userToken : '';

      // GET 请求参数拼接到 URL 上
      if (method.toUpperCase() === 'GET' && params) {
        const queryString = new URLSearchParams(params).toString();
        url = `${url}?${queryString}`;
      }
      // 非 GET 请求则将参数放入 body
      else if (params) {
        config.body = JSON.stringify(params);
      }
      try {
        const response = await fetch(url, config);
        loading.close();
        // 获取 content-type 判断是否是文件流
        const contentType = response.headers.get('content-type');

        // 如果是文件流（如 application/octet-stream 或 application/pdf）
        if (contentType && (contentType.includes('application/octet-stream') || contentType.includes('application/pdf'))) {
          const blob = await response.blob();

          // 提取文件名（从 Content-Disposition 中获取）
          let filename = 'download';
          const disposition = response.headers.get('content-disposition');
          if (disposition) {
            const fileNameMatch = disposition.match(/filename="?([^"]+)"?/);
            if (fileNameMatch?.[1]) {
              filename = decodeURIComponent(fileNameMatch[1]); // 处理中文等编码
            }
          }

          // 创建下载链接并触发
          const downloadUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = downloadUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(downloadUrl);
        } else if (contentType.includes('application/json')) {
          const json = await response.json();
          if (json.code != 0) {
            Vue.prototype.$message.error(json.msg || '请求失败');
          }
          throw new Error(json.msg || '请求失败');
        }
        // 否则按 JSON 处理
        else if (response.ok && contentType && contentType.includes('application/json')) {
          return await response.json();
        }
        // 其他情况
        else {
          throw new Error(`Unsupported content type: ${contentType}`);
        }

      } catch (error) {
        console.error('Download failed:', error);
        throw error;
      }
    },
    deepCopy(data) {
      const newData = new data.constructor();  //保持继承链
      for (var k in data) {
        if (data.hasOwnProperty(k)) { //不遍历其原型链上的属性
          var val = data[k]
          newData[k] = typeof val === 'object' ? this.deepCopy(val) : val;
        }
      }
      return newData;
    },
    easyDeepCopy(obj) {
      return JSON.parse(JSON.stringify(obj))
    },
    getPostsType(limits = []) {
      return store.state.posts ? store.state.posts.filter(item => !limits.includes(item.value)).map(item => item.value).join(",") : ''
    },
    // 兼容接口返回的多种结构，提取菜单数组（api/menu/setting/list）
    extractMenuListData(data) {
      if (Array.isArray(data)) return data;
      if (!data || typeof data !== 'object') return [];
      if (Array.isArray(data.data)) return data.data;
      if (Array.isArray(data.list)) return data.list;
      if (Array.isArray(data.records)) return data.records;
      return data.id || data.title ? [data] : [];
    },
    // 归一化为前端菜单树结构（title/icon/path/module/index/pindex/childs，保留 id/level）
    // 子节点字段兼容 children / childs / sub
    normalizeMenuData(list) {
      if (!Array.isArray(list)) return [];
      return list
        .map(item => {
          const children = Array.isArray(item.children) ? item.children
            : Array.isArray(item.childs) ? item.childs
            : Array.isArray(item.sub) ? item.sub : [];
          const node = {
            id: item.id !== undefined && item.id !== null ? item.id : '',
            title: item.title || item.name || '',
            icon: item.icon || '',
            path: item.path || '',
            module: item.module || '',
            level: item.level || '',
            index: item.index !== undefined && item.index !== null ? String(item.index) : '',
            pindex: item.pindex !== undefined && item.pindex !== null ? String(item.pindex) : '',
            sort: item.sort || 0
          };
          if (children.length) {
            node.childs = this.normalizeMenuData(children);
          }
          return node;
        })
        .sort((a, b) => (a.sort || 0) - (b.sort || 0));
    },
  }
}